import { useEffect, useState, useRef } from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

import Skeleton from '@mui/material/Skeleton';

import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Switch from '@mui/material/Switch';
import Divider from '@mui/material/Divider';
import Popper from '@mui/material/Popper';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Primarytheme from './theme';

import IconButton from '@mui/material/IconButton';
import Refresh from '@mui/icons-material/Refresh'

import { getAssetFoldersFromConf, mapTableData } from '../helpers/assets';

import { getSessionIdToken } from '../auth/apiAuth'

import axios from 'axios';

const {
    REACT_APP_USER_ID,
} = process.env;

export default function CoversIndesign({ conf, setConf, auth, authAll }) {


    const [refreshAsset, setRefreshAsset] = useState(1);

    const [assets, setAssets] = useState({

        fetching: true,
        refreshing: true,
        uploading: false,

        tag: null,
        refresh: 1,

        // navbar
        folders: [],

        // solo per images
        objectList: [],
        dataTables: [],
        dataTablesId: {},
        //selectionModel: [],

        // solo per indd
        inddValues: {},



    })

    const fetchS3Objects1 = async function ({ src, name, type, tags, sharedProjectId, obj = {}, i = 0 }) {
        let action = type === 'img' ? 'query-items-dynamo' : type;
        let body = {};

        if (action === 'additional-data') {
            action = 'query-items-dynamo';
            body = {
                project_id: sharedProjectId ? sharedProjectId : src.split('/').slice(1, 3).join('/'),
                selectedFolder: name,
                fullSize: obj[src] ? obj[src].fullSize : 0,
                filterUser: authAll.policy.filterUser ? authAll.user : false,
            }
        }
        if (action === 'indesign') {
            action = 'query-indesign-dynamo';
        }
        if (type === 'img') {
            body = {
                project_id: sharedProjectId ? sharedProjectId : src.split('/').slice(1, 3).join('/'),
                selectedFolder: name,
                LastEvaluatedKey: obj[src] ? obj[src].LastEvaluatedKey : undefined,
                fullSize: obj[src] ? obj[src].fullSize : 0,
                filterUser: authAll.policy.filterUser ? authAll.user : false,
            }
        }

        const token = await getSessionIdToken();
        return axios({
            method: "post",
            url: `${process.env.REACT_APP_API_BASE_URL}/assets`,
            headers: {
                'user_id': REACT_APP_USER_ID || auth.USER_ID,
                "content-type": "application/json",
                "Authorization": token,
                "src": src,
                "tags": JSON.stringify(tags),
                "action": action,
                "project_id": src.split('/').slice(1, 3).join('/'),
                "selectedFolder": name,
                "LastEvaluatedKey": obj[src] ? JSON.stringify(obj[src].LastEvaluatedKey) : undefined,
                "lastId": obj[src] ? obj[src].lastId : 0,
                "fullSize": obj[src] ? obj[src].fullSize : 0,
            },
            data: { ...body }
        })
            .then(resp => {
                if (type === 'img') {
                    if (!resp.data.LastEvaluatedKey && !obj[src]) {
                        return { data: { s3KeyList: resp.data.s3KeyList, fullSize: resp.data.fullSize }, type }
                    } else {
                        if (!obj[src] || (obj[src] && resp.data.LastEvaluatedKey !== undefined)) {
                            obj[src] = {
                                fullSize: resp.data.fullSize,
                                s3KeyList: obj[src] ? [...obj[src].s3KeyList, ...resp.data.s3KeyList] : resp.data.s3KeyList,
                                startAfter: resp.data.lastKey,
                                src,
                                type,
                                tags,
                                LastEvaluatedKey: resp.data.LastEvaluatedKey ? resp.data.LastEvaluatedKey : undefined,
                            }

                            i++;
                            // recusrive call
                            return fetchS3Objects1({ src, type, name, tags, sharedProjectId, obj, i });
                        } else {

                            // return with the updated data
                            obj[src] = {
                                fullSize: resp.data.fullSize,
                                s3KeyList: obj[src] ? [...obj[src].s3KeyList, ...resp.data.s3KeyList] : resp.data.s3KeyList,
                                startAfter: resp.data.lastKey,
                                src,
                                type,
                                tags,
                                LastEvaluatedKey: resp.data.LastEvaluatedKey ? resp.data.LastEvaluatedKey : 0,
                            }

                            return { data: { s3KeyList: obj[src].s3KeyList, fullSize: obj[src].fullSize }, type }
                        }
                    }
                } else if (type === 'indesign') {
                    // return as before
                    if (!resp.data.LastEvaluatedKey && !obj[src]) {
                        return { data: resp.data, type }
                    } else if ((!obj[src] && resp.data.LastEvaluatedKey) || (obj[src] && resp.data.LastEvaluatedKey)) {
                        // manage receiving tags
                        let tagsToObj = {};
                        if (obj[src]) {
                            const oldTags = obj[src].tagOrderedObj;
                            const newTags = resp.data.tagOrderedObj;
                            tagsToObj = { ...obj[src].tagOrderedObj };
                            for (const key in newTags) {
                                if (oldTags[key]) {
                                    let tagsArr = [...oldTags[key], ...newTags[key]];
                                    tagsArr = tagsArr.filter((value, index, self) => index === self.findIndex((t) => (t.name === value.name)))
                                    tagsToObj[key] = [...tagsArr];
                                } else {
                                    tagsToObj[key] = [...newTags[key]];
                                }
                            }
                        } else {
                            tagsToObj = { ...resp.data.tagOrderedObj };
                        }

                        // caso particolare con last evalueted key
                        if (obj[src] && obj[src].inddList) {
                            const respInddMap = new Map();
                            resp.data.inddList.forEach(el => respInddMap.set(el.reqid, el));

                            const objInddMap = new Map();
                            obj[src].inddList.forEach(el => objInddMap.set(el.reqid, el));

                            for (const [reqid, value] of objInddMap) {
                                if (respInddMap.has(reqid)) {
                                    objInddMap.set(reqid, {
                                        ...value,
                                        fonts: [...value.fonts, ...respInddMap.get(reqid).fonts],
                                        links: [...value.links, ...respInddMap.get(reqid).links],
                                        bucket: value.bucket ? value.bucket : respInddMap.get(reqid).bucket,
                                        filename: value.filename !== 'undefined' ? value.filename : respInddMap.get(reqid).filename,
                                        idml: value.idml ? value.idml : respInddMap.get(reqid).idml,
                                        indd: value.indd ? value.indd : respInddMap.get(reqid).indd,
                                        jpg: value.jpg ? value.jpg : respInddMap.get(reqid).jpg,
                                        keyName: value.keyName ? value.keyName : respInddMap.get(reqid).keyName,
                                        lastModified: value.lastModified ? value.lastModified : respInddMap.get(reqid).lastModified,
                                        linksCheckArr: value.linksCheckArr ? value.linksCheckArr : respInddMap.get(reqid).linksCheckArr,
                                        reqid: value.reqid ? value.reqid : respInddMap.get(reqid).reqid,
                                        size: value.size ? value.size : respInddMap.get(reqid).size,
                                        tags: value.tags ? value.tags : respInddMap.get(reqid).tags,
                                        unusedLinksArr: value.unusedLinksArr ? value.unusedLinksArr : respInddMap.get(reqid).unusedLinksArr,
                                    })

                                    // cancella reqid già processati
                                    respInddMap.delete(reqid);
                                }
                            }
                            for (const [reqid, value] of respInddMap) {
                                objInddMap.set(reqid, {
                                    ...value,
                                    fonts: [...value.fonts, ...respInddMap.get(reqid).fonts],
                                    links: [...value.links, ...respInddMap.get(reqid).links],
                                    bucket: value.bucket ? value.bucket : respInddMap.get(reqid).bucket,
                                    filename: value.filename !== 'undefined' ? value.filename : respInddMap.get(reqid).filename,
                                    idml: value.idml ? value.idml : respInddMap.get(reqid).idml,
                                    indd: value.indd ? value.indd : respInddMap.get(reqid).indd,
                                    jpg: value.jpg ? value.jpg : respInddMap.get(reqid).jpg,
                                    keyName: value.keyName ? value.keyName : respInddMap.get(reqid).keyName,
                                    lastModified: value.lastModified ? value.lastModified : respInddMap.get(reqid).lastModified,
                                    linksCheckArr: value.linksCheckArr ? value.linksCheckArr : respInddMap.get(reqid).linksCheckArr,
                                    reqid: value.reqid ? value.reqid : respInddMap.get(reqid).reqid,
                                    size: value.size ? value.size : respInddMap.get(reqid).size,
                                    tags: value.tags ? value.tags : respInddMap.get(reqid).tags,
                                    unusedLinksArr: value.unusedLinksArr ? value.unusedLinksArr : respInddMap.get(reqid).unusedLinksArr,
                                })
                            }

                            obj[src].inddList = [];
                            objInddMap.forEach((value, key, map) => obj[src].inddList.push(value))
                        }

                        obj[src] = {
                            ...obj[src],
                            fullSize: (obj[src] ? Number(obj[src].fullSize) : 0) + Number(resp.data.fullSize),
                            inddList: (obj[src] && obj[src].inddList) ? obj[src].inddList : [...resp.data.inddList],
                            tagOrderedObj: tagsToObj,
                            LastEvaluatedKey: resp.data.LastEvaluatedKey ? JSON.parse(resp.data.LastEvaluatedKey) : undefined,
                        }

                        i++;
                        // recusrive call
                        return fetchS3Objects1({ src, name, type, tags, sharedProjectId, obj, i });
                    } else {
                        let tagsToObj = {};
                        if (obj[src]) {
                            const oldTags = obj[src].tagOrderedObj;
                            const newTags = resp.data.tagOrderedObj;
                            tagsToObj = { ...obj[src].tagOrderedObj };
                            for (const key in newTags) {
                                if (oldTags[key]) {
                                    let tagsArr = [...oldTags[key], ...newTags[key]];
                                    tagsArr = tagsArr.filter((value, index, self) => index === self.findIndex((t) => (t.name === value.name)))
                                    tagsToObj[key] = [...tagsArr];
                                } else {
                                    tagsToObj[key] = [...newTags[key]];
                                }
                            }

                        } else {
                            tagsToObj = { ...resp.data.tagOrderedObj };
                        }

                        // caso particolare con last evalueted key
                        if (obj[src] && obj[src].inddList) {
                            const respInddMap = new Map();
                            resp.data.inddList.forEach(el => respInddMap.set(el.reqid, el));

                            const objInddMap = new Map();
                            obj[src].inddList.forEach(el => objInddMap.set(el.reqid, el));

                            for (const [reqid, value] of objInddMap) {
                                if (respInddMap.has(reqid)) {
                                    objInddMap.set(reqid, {
                                        ...value,
                                        fonts: [...value.fonts, ...respInddMap.get(reqid).fonts],
                                        links: [...value.links, ...respInddMap.get(reqid).links],
                                        bucket: value.bucket ? value.bucket : respInddMap.get(reqid).bucket,
                                        filename: value.filename !== 'undefined' ? value.filename : respInddMap.get(reqid).filename,
                                        idml: value.idml ? value.idml : respInddMap.get(reqid).idml,
                                        indd: value.indd ? value.indd : respInddMap.get(reqid).indd,
                                        jpg: value.jpg ? value.jpg : respInddMap.get(reqid).jpg,
                                        keyName: value.keyName ? value.keyName : respInddMap.get(reqid).keyName,
                                        lastModified: value.lastModified ? value.lastModified : respInddMap.get(reqid).lastModified,
                                        linksCheckArr: value.linksCheckArr ? value.linksCheckArr : respInddMap.get(reqid).linksCheckArr,
                                        reqid: value.reqid ? value.reqid : respInddMap.get(reqid).reqid,
                                        size: value.size ? value.size : respInddMap.get(reqid).size,
                                        tags: value.tags ? value.tags : respInddMap.get(reqid).tags,
                                        unusedLinksArr: value.unusedLinksArr ? value.unusedLinksArr : respInddMap.get(reqid).unusedLinksArr,
                                    })

                                    // cancella reqid già processati
                                    respInddMap.delete(reqid);
                                }
                            }

                            for (const [reqid, value] of respInddMap) {
                                objInddMap.set(reqid, {
                                    ...value,
                                    fonts: [...value.fonts, ...respInddMap.get(reqid).fonts],
                                    links: [...value.links, ...respInddMap.get(reqid).links],
                                    bucket: value.bucket ? value.bucket : respInddMap.get(reqid).bucket,
                                    filename: value.filename !== 'undefined' ? value.filename : respInddMap.get(reqid).filename,
                                    idml: value.idml ? value.idml : respInddMap.get(reqid).idml,
                                    indd: value.indd ? value.indd : respInddMap.get(reqid).indd,
                                    jpg: value.jpg ? value.jpg : respInddMap.get(reqid).jpg,
                                    keyName: value.keyName ? value.keyName : respInddMap.get(reqid).keyName,
                                    lastModified: value.lastModified ? value.lastModified : respInddMap.get(reqid).lastModified,
                                    linksCheckArr: value.linksCheckArr ? value.linksCheckArr : respInddMap.get(reqid).linksCheckArr,
                                    reqid: value.reqid ? value.reqid : respInddMap.get(reqid).reqid,
                                    size: value.size ? value.size : respInddMap.get(reqid).size,
                                    tags: value.tags ? value.tags : respInddMap.get(reqid).tags,
                                    unusedLinksArr: value.unusedLinksArr ? value.unusedLinksArr : respInddMap.get(reqid).unusedLinksArr,
                                })
                            }

                            obj[src].inddList = [];
                            objInddMap.forEach((value, key, map) => obj[src].inddList.push(value))
                        }

                        obj[src] = {
                            ...obj[src],
                            fullSize: Number(resp.data.fullSize),
                            inddList: obj[src].inddList ? obj[src].inddList : [...resp.data.inddList],
                            tagOrderedObj: tagsToObj,
                            LastEvaluatedKey: resp.data.LastEvaluatedKey ? JSON.parse(resp.data.LastEvaluatedKey) : undefined,
                        }

                        return { data: { ...obj[src] }, type }
                    }
                } else {
                    // return as before
                    return { data: resp.data, type }
                }
            })
            .catch(() => {
                return { data: { s3KeyList: [], inddList: [], fullSize: 0, tagOrderedObj: {} }, type, error: true }
            });

    }

    const handleChangeCover = function ({ event, id, value }) {
        if (id >= 0 && assets.dataTables[id]) {
            const newConfSelected = [...conf.selectedCovers];
            const isMultiple = newConfSelected[id].multiple;

            if (isMultiple) {
                const selectedArray = value || [];
                newConfSelected[id].value = selectedArray.map(v => v.indd.Name.indexOf('/') === -1 ? v.reqid + '/' + v.indd.Name : v.indd.Name);
                newConfSelected[id].fullPath = selectedArray.map(v => v.indd.fullPath);
                newConfSelected[id].filename = selectedArray.map(v => v.filename);
                newConfSelected[id].reqId = selectedArray.map(v => v.reqid);
                newConfSelected[id].tagsValues = selectedArray.map(v => Object.values(v.tags).join(' '));
                newConfSelected[id].indd = selectedArray;
                newConfSelected[id].jpg = selectedArray.length > 0 ? selectedArray[selectedArray.length - 1].jpg : undefined;
            } else if (value) {
                const indd = assets.dataTables[id].filter(indd => indd.reqid === value.reqid)[0];
                newConfSelected[id].value = indd.indd.Name.indexOf('/') === -1 ? indd.reqid + '/' + indd.indd.Name : indd.indd.Name;
                newConfSelected[id].folder = indd.indd.prefix;
                newConfSelected[id].filename = indd.filename;
                newConfSelected[id].fullPath = indd.indd.fullPath;
                newConfSelected[id].reqId = indd.reqid;
                newConfSelected[id].tagsValues = Object.values(indd.tags).join(' ');
                newConfSelected[id].indd = indd;
                newConfSelected[id].jpg = indd.jpg;
            }
            else {
                newConfSelected[id].value = '';
                newConfSelected[id].indd = undefined;
                newConfSelected[id].tags = newConfSelected[id].tags;
                newConfSelected[id].tagsValues = '';
                newConfSelected[id].reqId = '';
                newConfSelected[id].jpg = undefined;
            }

            setConf({ ...conf, selectedCovers: newConfSelected });
        }
    }

    const handleChangeCheckOption = (idDoc, newValue) => {
        const newConfSelected = [...conf.selectedCovers];
        newConfSelected[idDoc].noCover = newValue;
        newConfSelected[idDoc].value = '';
        newConfSelected[idDoc].indd = undefined;
        newConfSelected[idDoc].fullPath = '';
        newConfSelected[idDoc].tags = newConfSelected[idDoc].tags;
        newConfSelected[idDoc].tagsValues = '';
        newConfSelected[idDoc].reqId = ''; // clear selection   
        newConfSelected[idDoc].jpg = undefined

        if (newValue) {
            newConfSelected[idDoc].value = 'ignore';
            newConfSelected[idDoc].filename = 'ignore';
            newConfSelected[idDoc].tagsValues = 'ignore';
        }
        //console.log(newConfSelected[idDoc])
        setConf({ ...conf, selectedCovers: newConfSelected });
    }

    const refreshPage = function () {
        setRefreshAsset(!refreshAsset)
    }
    // retrieve conf after selected project
    useEffect(() => {

        // console.log('use effect get folders');
        // setAssets({ ...assets, refreshing: true })
        const assetFolders = getAssetFoldersFromConf(conf, authAll).filter(src => src.type === 'indesign' && !src.automatic);
        //  setAssets({ ...assets, folders: assetFolders, conf: projectConf })
        // console.log('assetFolders: ', assetFolders);
        const promises = [];
        for (const src of assetFolders) {
            if (!src.automatic) {
                promises.push(fetchS3Objects1({
                    src: src.s3,
                    name: src.name,
                    type: 'indesign',
                    tags: src.tags,
                    sharedProjectId: src.sharedProjectId,
                }))
            }
        }

        Promise.all(promises)
            .then(folderResList => {
                const dataTables = folderResList.map((singleFolder, index) => {

                    const table = singleFolder.data.inddList
                        .filter(doc => doc.indd !== undefined)
                        .map(doc => {
                            if (doc.indd) {
                                doc.indd.prefix = assetFolders[index].name;
                                return doc
                            }
                        })

                    table.tagOrderedObj = singleFolder.data.tagOrderedObj;
                    return table
                })
                setAssets({ ...assets, folders: assetFolders, dataTables, conf, fetching: false, refreshing: false })


                // init value first of the list
                const newConfSelected = [...conf.selectedCovers];
                for (let id = 0; id < dataTables.length; id++) {
                    const isMultiple = newConfSelected[id] && newConfSelected[id].multiple;

                    // set ignore if no idml uploaded
                    const tagKeys = Object.keys(dataTables[id].tagOrderedObj || {});
                    if (tagKeys.length > 0 && dataTables[id].tagOrderedObj[tagKeys[0]].length === 0) {
                        newConfSelected[id].value = isMultiple ? [] : 'ignore';
                        newConfSelected[id].filename = isMultiple ? [] : 'ignore';
                        newConfSelected[id].tagsValues = isMultiple ? [] : 'ignore';
                        continue;
                    }

                    if (isMultiple) {
                        // multi-select: start empty, user picks manually
                        newConfSelected[id].value = [];
                        newConfSelected[id].fullPath = [];
                        newConfSelected[id].filename = [];
                        newConfSelected[id].reqId = [];
                        newConfSelected[id].tagsValues = [];
                        newConfSelected[id].indd = [];
                        newConfSelected[id].jpg = undefined;
                    } else {
                        const indd = dataTables[id][0];
                        if (indd && conf.selectedCovers[id] && conf.selectedCovers[id].value !== 'ignore') {
                            newConfSelected[id].value = indd.indd.Name.indexOf('/') === -1 ? indd.reqid + '/' + indd.indd.Name : indd.indd.Name;
                            newConfSelected[id].folder = indd.indd.prefix;
                            newConfSelected[id].filename = indd.filename;
                            newConfSelected[id].fullPath = indd.indd.fullPath;
                            newConfSelected[id].reqId = indd.reqid;
                            newConfSelected[id].tagsValues = Object.values(indd.tags).join(' ');
                            newConfSelected[id].indd = indd;
                            newConfSelected[id].jpg = indd.jpg;
                        }
                    }
                }
                setConf({ ...conf, selectedCovers: newConfSelected });


            })


    }, [refreshAsset]);



    return (
        <Box>
            <Box sx={{ marginTop: '2em' }} >
                {conf.selectedCovers.map((doc, id) => {
                    //if(!doc.tags) doc.tags = ['tag'];
                    // console.log(doc)
                    return (

                        <Stack key={doc.folder} direction='row' sx={{ height: '10em', mb: '1em' }} alignItems='center'>
                            <Box sx={{ flexShrink: 0, width: 500 }}>
                                <Box mb='1em'>
                                    <b>{doc.folder}</b>
                                </Box>
                                <Box>
                                    {assets.fetching && <Skeleton variant="rectangular" animation="wave" height={40} sx={{ width: 400 }} />}
                                    {!assets.fetching && (
                                        <Stack direction='row' spacing={2}>
                                            {!doc.required && assets.dataTables[id] && assets.dataTables[id].tagOrderedObj &&
                                                <Switch
                                                    disabled={assets.dataTables[id].tagOrderedObj[Object.keys(assets.dataTables[id].tagOrderedObj)[0]].length === 0}
                                                    checked={!doc.noCover && assets.dataTables[id].tagOrderedObj[Object.keys(assets.dataTables[id].tagOrderedObj)[0]].length !== 0}
                                                    defaultChecked
                                                    onChange={(e) => handleChangeCheckOption(id, !e.target.checked)}
                                                />
                                            }

                                            <Autocomplete id="tag-selector"
                                                disablePortal
                                                disabled={doc.noCover || assets.dataTables[id].tagOrderedObj[Object.keys(assets.dataTables[id].tagOrderedObj)[0]].length === 0}
                                                multiple={doc.multiple || false}
                                                options={assets.dataTables[id]}
                                                sx={{ width: 'fit-content', minWidth: 300 }}
                                                clearOnEscape
                                                disableCloseOnSelect={doc.multiple || false}
                                                value={doc.multiple ? (Array.isArray(doc.indd) ? doc.indd : []) : (doc.indd || { reqid: '' })}
                                                onChange={(event, value) => handleChangeCover({ event, id, value })}
                                                size='small'
                                                isOptionEqualToValue={(option, value) => option.reqid === value.reqid}
                                                getOptionLabel={(option) => {
                                                    return option.tags ? Object.values(option.tags).join(' ') : ''
                                                }}
                                                renderInput={(params) => <TextField {...params} placeholder={doc.tags ? doc.tags.join(' ') : undefined} />}
                                            />
                                            <IconButton onClick={refreshPage} > <Refresh /> </IconButton>

                                        </Stack>
                                    )}
                                </Box>
                            </Box>
                            {!doc.noCover && assets.dataTables[id] && assets.dataTables[id].tagOrderedObj && assets.dataTables[id].tagOrderedObj[Object.keys(assets.dataTables[id].tagOrderedObj)[0]].length > 0 && (
                                <CoverPreview jpg={doc.jpg} isFetching={assets.fetching} extraCount={doc.multiple && Array.isArray(doc.indd) && doc.indd.length > 1 ? doc.indd.length - 1 : 0} />
                            )}
                        </Stack>
                    )

                })}
            </Box>

        </Box >

    )
}



function CoverPreview({ jpg, isFetching, extraCount = 0 }) {
    const [loaded, setLoaded] = useState(false);
    function onLoad() {
        setLoaded(true);
    }

    useEffect(() => {
        if (loaded) setLoaded(false);
    }, [jpg])


    if (isFetching) return <Skeleton variant="rectangular" animation="wave" sx={{ width: 350, height: '8em' }} />
    else if (jpg) return (
        <Stack direction={'column'}>
            <Box
                sx={{
                    width: 350,
                    flexShrink: 0,
                    height: '8em',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    overflow: 'hidden',
                    position: 'relative',
                }}
            >
                {!loaded && <CircularProgress variant='indeterminate' size={25} />}
                <img
                    style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain', display: loaded ? 'block' : 'none' }}
                    onLoad={onLoad}
                    src={jpg}
                    alt={''}
                />
            </Box>
            {extraCount > 0 && loaded && (
                <Typography
                    variant='caption'
                    sx={{
                        color: Primarytheme.palette.neutral.main,
                        fontSize: '1rem',
                    }}
                >
                    + {extraCount}
                </Typography>
            )}
        </Stack>
    )
    else return null
}